<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    mounted() {
       
    },
    watch: {
        model(value) {
            
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )
               

                if (this.field.key == 'basicInfo.religionId') {
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.religion',
                        value: selectedItem.value,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.religion',
                        value: selectedItem.title,
                    })

                    
                }
            }
        },
    }, // End of Component > watch
}
</script>
